module.exports = __webpack_public_path__ + "img/user_login.png";